export default "__VITE_ASSET__C3vCsuu9__"